import React, { useState } from "react";
import { Form, Button, Col, Container, Row } from "react-bootstrap";
import AdvancedAddressesFilters from "../../Addresses/AdvancedAddressesFilters";
import PostcodeInput from "../../Common/PostcodeInput";

const missingFieldOptions = [
  { label: "Nr domu", value: "Number" },
  { label: "Nr domu (całk.)", value: "NumberInt" },
  { label: "Terminal EX", value: "TerminalEx" },
  { label: "Terminal DR", value: "TerminalDr" },
  { label: "EX_PN", value: "ExPn" },
  { label: "EX_WT", value: "ExWt" },
  { label: "EX_SR", value: "ExSr" },
  { label: "EX_CZ", value: "ExCz" },
  { label: "EX_PT", value: "ExPt" },
  { label: "EX_SO", value: "ExSo" },
  { label: "DR_PN", value: "DrPn" },
  { label: "DR_WT", value: "DrWt" },
  { label: "DR_SR", value: "DrSr" },
  { label: "DR_CZ", value: "DrCz" },
  { label: "DR_PT", value: "DrPt" },
  { label: "DR_SO", value: "DrSo" },
  { label: "W_PN", value: "WPn" },
  { label: "W_WT", value: "WWt" },
  { label: "W_SR", value: "WSr" },
  { label: "W_CZ", value: "WCz" },
  { label: "W_PT", value: "WPt" },
  { label: "RES_PN_OD", value: "ResPnOd" },
  { label: "RES_PN_DO", value: "ResPnDo" },
  { label: "RES_WT_OD", value: "ResWtOd" },
  { label: "RES_WT_DO", value: "ResWtDo" },
  { label: "RES_SR_OD", value: "ResSrOd" },
  { label: "RES_SR_DO", value: "ResSrDo" },
  { label: "RES_CZ_OD", value: "ResCzOd" },
  { label: "RES_CZ_DO", value: "ResCzDo" },
  { label: "RES_PT_OD", value: "ResPtOd" },
  { label: "RES_PT_DO", value: "ResPtDo" },
  { label: "RES_SO_OD", value: "ResSoOd" },
  { label: "RES_SO_DO", value: "ResSoDo" },
  { label: "LastB_PN", value: "LastBPn" },
  { label: "LastB_WT", value: "LastBWt" },
  { label: "LastB_SR", value: "LastBSr" },
  { label: "LastB_CZ", value: "LastBCz" },
  { label: "LastB_PT", value: "LastBPt" },
  { label: "LastB_SO", value: "LastBSo" },
  { label: "Service 9", value: "Service9" },
  { label: "Service 12", value: "Service12" },
  { label: "Service 17_22", value: "Service1722" },
  { label: "SO_N", value: "SoN" },
  { label: "SO_O", value: "SoO" },
  { label: "Obszar", value: "Region" },
  { label: "Budynek", value: "Building" },
  { label: "Budynek DHL", value: "BuildingDHL" },
  { label: "Strefa", value: "ZoneName" },
  { label: "EX_HIST", value: "ExHist" },
  { label: "EX_HIST_FROM", value: "ExHistFrom" },
  { label: "EX_HIST_TO", value: "ExHistTo" },
  { label: "DR_HIST", value: "DrHist" },
  { label: "DR_HIST_FROM", value: "DrHistFrom" },
  { label: "DR_HIST_TO", value: "DrHistTo" },
  { label: "EX_COM_MET", value: "ExComMet" },
];

const AddressesMissingFieldsFilters = ({
  onFilterChange,
  onSearch,
  onImmediateFilterChange,
  filters = {},
}) => {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [showMissingFields, setShowMissingFields] = useState(false);
  const selectedMissingFields = Array.isArray(filters.missingFields)
    ? filters.missingFields
    : [];

  const toggleMissingField = (value) => {
    const next = selectedMissingFields.includes(value)
      ? selectedMissingFields.filter((item) => item !== value)
      : [...selectedMissingFields, value];
    if (onImmediateFilterChange) {
      onImmediateFilterChange("missingFields", next);
    } else {
      onFilterChange("missingFields", next);
    }
  };

  return (
    <Container className="mt-4">
      <Form
        onKeyDown={(e) => {
          if (
            e.key === "Enter" &&
            !["TEXTAREA", "SELECT"].includes(e.target.tagName)
          ) {
            e.preventDefault();
            onSearch?.();
          }
        }}
      >
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="cityName">
              <Form.Label>Miejscowość</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.cityName || ""}
                onChange={(e) => onFilterChange("cityName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcode">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                value={filters.postcode || ""}
                onChange={(val) => onFilterChange("postcode", val)}
                inputMode="numeric"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="streetName">
              <Form.Label>Ulica</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.streetName || ""}
                onChange={(e) => onFilterChange("streetName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalDR">
              <Form.Label>Terminal DR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalDR || filters.terminalDr || ""}
                onChange={(e) => onFilterChange("terminalDR", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalEX">
              <Form.Label>Terminal EX</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.terminalEX || filters.terminalEx || ""}
                onChange={(e) => onFilterChange("terminalEX", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2} className="d-flex align-items-end">
            <Button
              variant="primary"
              type="button"
              className="w-100"
              style={{ backgroundColor: "#D40511", borderColor: "#D40511" }}
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            >
              {showAdvancedFilters ? "Podstawowy" : "Zaawansowany"}
            </Button>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <Button
              variant="primary"
              type="button"
              className="w-100"
              style={{ backgroundColor: "#D40511", borderColor: "#D40511" }}
              onClick={() => setShowMissingFields(!showMissingFields)}
            >
              {showMissingFields
                ? "Ukryj dodatkowe filtry"
                : "Dodatkowe filtry"}
            </Button>
          </Col>
        </Row>
        {showMissingFields && (
          <Row className="mb-3">
            <Col>
              <Form.Label>
                Oznacz wybrane kolumny w celu dodania filtru i wyświetlenia
                wierszy z pustymi ich wartościami.
              </Form.Label>
              <Row>
                {missingFieldOptions.map((option) => (
                  <Col key={option.value} md={3} className="mb-2">
                    <Form.Check
                      type="checkbox"
                      id={`missing-${option.value}`}
                      label={option.label}
                      checked={selectedMissingFields.includes(option.value)}
                      onChange={() => toggleMissingField(option.value)}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        )}
        {showAdvancedFilters && (
          <AdvancedAddressesFilters
            onFilterChange={onFilterChange}
            onImmediateFilterChange={onImmediateFilterChange}
            filters={filters}
          />
        )}
      </Form>
    </Container>
  );
};

export default AddressesMissingFieldsFilters;
